var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weixin-button-small"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/wechat_logo.svg"),"alt":""},on:{"click":_vm.onBtnClick}}),(!_vm.isEditor)?_c('wx-modal',{ref:"modal",attrs:{"data":_vm.content.modal,"content":_vm.content}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }